@if (card) {
  <div class="gameplay__player">
    @switch (card.template.gameplay.type) {
      @case ('tiles') {
        <gameplay-tiles [setting]="setting" [card]="card" [didAnswer]="didAnswer" (selected)="onSelect($event)"></gameplay-tiles>
      }
      @case ('stack') {
        <gameplay-stack [setting]="setting" [card]="card" [didAnswer]="didAnswer" (selected)="onSelect($event)"></gameplay-stack>
      }
      @case ('numbers') {
        <gameplay-numbers [setting]="setting" [card]="card" [didAnswer]="didAnswer" (selected)="onSelect($event)"></gameplay-numbers>
      }
      @case ('diagram') {
        <gameplay-diagram [setting]="setting" [card]="card" [didAnswer]="didAnswer" (selected)="onSelect($event)"></gameplay-diagram>
      }
      @case ('periodic') {
        <gameplay-periodic [setting]="setting" [card]="card" [didAnswer]="didAnswer" (selected)="onSelect($event)"></gameplay-periodic>
      }
      @case ('fill') {
        <gameplay-fill [setting]="setting" [card]="card" [didAnswer]="didAnswer" (selected)="onSelect($event)"></gameplay-fill>
      }
      @case ('flip') {
        <gameplay-flip [setting]="setting" [card]="card" [didAnswer]="didAnswer" (selected)="onSelect($event)"></gameplay-flip>
      }
      @default {
        <div [ngStyle]="{'display': 'flex', 'justifyContent': 'center', 'alignItems': 'center'}">no Angular gameplay for {{card.id}}</div>
      }
    }
  </div>
}
